/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { JsonRpcBatchProvider, JsonRpcProvider } from '@ethersproject/providers'
import { Network } from '@ethersproject/networks'
import { defineReadOnly } from '@ethersproject/properties'
import { Chains } from '../chains'

class StaticJsonRpcBatchProvider extends JsonRpcBatchProvider {
  async detectNetwork(): Promise<Network> {
    let network = this.network

    if (network == null) {
      network = await super.detectNetwork()

      // If still not set, set it
      if (this._network == null) {
        // A static network does not support "any"
        defineReadOnly(this, '_network', network)

        this.emit('network', network, null)
      }
    }

    return network
  }
}

const createProviderGetter = <P extends typeof JsonRpcProvider>(
  Provider: P,
) => {
  const cache = new Map<string, InstanceType<P>>()

  return (
    chainId: Chains,
    url: string,
    cacheSeed = 0,
    pollingInterval: number | null = null,
  ): InstanceType<P> => {
    const cacheKey = `${chainId}-${cacheSeed}-${url}`
    let provider = cache.get(cacheKey)

    if (!provider) {
      provider = new Provider(url, chainId) as InstanceType<P>
      cache.set(cacheKey, provider)
    }

    if (pollingInterval) {
      provider.pollingInterval = pollingInterval
    }

    return provider
  }
}

export const getStaticRpcBatchProvider = createProviderGetter(
  StaticJsonRpcBatchProvider,
)
